<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('tank_manufacturers.create')"
                                @invoke-method="invokeMethod($event)"
                                action="showTankManufacturer"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetTankManufacturers()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="tank_manufacturers" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr
                                class="clickable"
                                @mouseup.left="$router.push({ name: 'tank_manufacturer_profile', params: { id: props.item.manufacturer_id } })"
                            >
                                <td>{{ props.item.manufacturer }}</td>
                                <td>{{ props.item.contact_name }}</td>
                                <td>{{ props.item.phone }}</td>
                                <td>{{ props.item.email }}</td>
                                <td>{{ props.item.website }}</td>
                                <td>{{ props.item.notes }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="tank_manufacturer"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="tank_manufacturer_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{
                            currObjField("manufacturer_id") ? $t("lang.edit_tank_manufacturer") : $t("lang.add_tank_manufacturer")
                        }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeTankManufacturerDialog"
                            :dialog-status="tank_manufacturer_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="tank_manufacturer">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="tank_manufacturer_dialog"
                                            v-model="tank_manufacturer.manufacturer"
                                            :label="`${$t('lang.manufacturer')} *`"
                                            :counter="showCounter(tank_manufacturer.manufacturer, 'tank_manufacturer.manufacturer')"
                                            :rules="ifValid('tank_manufacturer.manufacturer')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturer.contact_name"
                                            :label="$t('lang.contact_name')"
                                            :counter="showCounter(tank_manufacturer.contact_name, 'tank_manufacturer.contact_name')"
                                            :rules="ifValid('tank_manufacturer.contact_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturer.phone"
                                            :label="$t('lang.phone')"
                                            :counter="showCounter(tank_manufacturer.phone, 'tank_manufacturer.phone')"
                                            :rules="ifValid('tank_manufacturer.phone')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturer.email"
                                            :label="$t('lang.email')"
                                            :counter="showCounter(tank_manufacturer.email, 'tank_manufacturer.email')"
                                            :rules="ifValid('tank_manufacturer.email')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturer.website"
                                            :label="$t('lang.website')"
                                            :counter="showCounter(tank_manufacturer.website, 'tank_manufacturer.website')"
                                            :rules="ifValid('tank_manufacturer.website')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="tank_manufacturer.notes"
                                            :label="$t('lang.notes')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('tank_manufacturer.notes')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('manufacturer_id')" color="error" @mouseup.left="$refs.delete_tank_manufacturer.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeTankManufacturerDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            color="success"
                            @mouseup.left="modifyTankManufacturer(currObjField('manufacturer_id') ? 'patch' : 'post', currObjField('manufacturer_id'))"
                            >{{ $t("lang.save") }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <!-- <delete-confirmation-dialog
                ref="delete_tank_manufacturer"
                :heading="$t('lang.delete_tank_manufacturer')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyTankManufacturer('delete', currObjField('manufacturer_id'))"
            ></delete-confirmation-dialog> -->
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.manufacturer"), sortable: false },
                { text: this.$t("lang.contact_name"), sortable: false },
                { text: this.$t("lang.phone"), sortable: false },
                { text: this.$t("lang.email"), sortable: false },
                { text: this.$t("lang.website"), sortable: false },
                { text: this.$t("lang.notes"), sortable: false },
            ],

            tank_manufacturer: {
                manufacturer: "",
                contact_name: "",
                phone: "",
                notes: "",
                email: "",
                website: "",
            },
            filter: {
                search: "",

                page_size: 0,
                page_num: 0,
            },
            tank_manufacturer_dialog: false,
            mobile_list: [
                {
                    title: this.$t("lang.add_new"),
                    action: "showTankManufacturer",
                },
                {
                    title: this.$t("lang.refresh"),
                    action: "dbGetTankManufacturers",
                },
            ],
            dbGetTankManufacturers: _.debounce(this.getTankManufacturers, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchTankManufacturer", {
                url: "tank_manufacturers",
                method: "get",
                stateProperty: "tank_manufacturers",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tank_manufacturers) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchTankManufacturer", {
                url: "tank_manufacturers",
                method: "get",
                stateProperty: "tank_manufacturers",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tank_manufacturers) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_tank_manufacturer: (state) => state.validation.rules_tank_manufacturer,
            default_filter: (state) => state.tank_manufacturers.tank_manufacturers_filter,
            page: (state) => state.tank_manufacturers.page,
            tank_manufacturers: (state) => state.tank_manufacturers.tank_manufacturers,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        closeTankManufacturerDialog() {
            this.tank_manufacturer_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getTankManufacturers() {
            this.startLoader();
            this.$store
                .dispatch("fetchTankManufacturer", {
                    url: "tank_manufacturers",
                    method: "get",
                    stateProperty: "tank_manufacturers",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.tank_manufacturer_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyTankManufacturer(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("tank_manufacturer")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchTankManufacturer", {
                                pk: "manufacturer_id",
                                id: id,
                                url: `tank_manufacturers/${id ? id : ""}`,
                                method: method,
                                stateProperty: "tank_manufacturers",
                                // mutate: true,
                                body: this.tank_manufacturer,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.$router.push({
                                        name: "tank_manufacturer_profile",
                                        params: {
                                            id: data.tank_manufacturers.manufacturer_id,
                                        },
                                    });
                                    // this.closeTankManufacturerDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showTankManufacturer(item = null) {
            this.current_obj = item;

            if (this.$refs.tank_manufacturer) item ? this.$refs.tank_manufacturer.resetValidation() : this.$refs.tank_manufacturer.reset();

            this.$nextTick(() => {
                this.assignObj(this.tank_manufacturer, item, this.rules_tank_manufacturer);
                this.tank_manufacturer_dialog = true;
            });
        },
    },
};
</script>
